// deck.gl-community
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import throttle from 'lodash.throttle';
import { getPickedEditHandle } from "./utils.js";
import { DrawPolygonMode } from "./draw-polygon-mode.js";
export class DrawPolygonByDraggingMode extends DrawPolygonMode {
    handleDraggingThrottled = null;
    handleClick(event, props) {
        // No-op
    }
    handleStartDragging(event, props) {
        event.cancelPan();
        if (props.modeConfig && props.modeConfig.throttleMs) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.handleDraggingThrottled = throttle(this.handleDraggingAux, props.modeConfig.throttleMs);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.handleDraggingThrottled = this.handleDraggingAux;
        }
    }
    handleStopDragging(event, props) {
        this.addClickSequence(event);
        const clickSequence = this.getClickSequence();
        // @ts-expect-error cancel() not typed
        if (this.handleDraggingThrottled && this.handleDraggingThrottled.cancel) {
            // @ts-expect-error cancel() not typed
            this.handleDraggingThrottled.cancel();
        }
        if (clickSequence.length > 2) {
            // Complete the polygon.
            const polygonToAdd = {
                type: 'Polygon',
                coordinates: [[...clickSequence, clickSequence[0]]]
            };
            const editAction = this.getAddFeatureOrBooleanPolygonAction(polygonToAdd, props);
            if (editAction) {
                props.onEdit(editAction);
            }
        }
        this.resetClickSequence();
    }
    handleDraggingAux(event, props) {
        const { picks } = event;
        const clickedEditHandle = getPickedEditHandle(picks);
        if (!clickedEditHandle) {
            // Don't add another point right next to an existing one.
            this.addClickSequence(event);
            props.onEdit({
                updatedData: props.data,
                editType: 'addTentativePosition',
                editContext: {
                    position: event.mapCoords
                }
            });
        }
    }
    handleDragging(event, props) {
        if (this.handleDraggingThrottled) {
            this.handleDraggingThrottled(event, props);
        }
    }
    handleKeyUp(event, props) {
        if (event.key === 'Enter') {
            const clickSequence = this.getClickSequence();
            if (clickSequence.length > 2) {
                const polygonToAdd = {
                    type: 'Polygon',
                    coordinates: [[...clickSequence, clickSequence[0]]]
                };
                this.resetClickSequence();
                const editAction = this.getAddFeatureOrBooleanPolygonAction(polygonToAdd, props);
                if (editAction) {
                    props.onEdit(editAction);
                }
            }
        }
        else if (event.key === 'Escape') {
            this.resetClickSequence();
            if (this.handleDraggingThrottled) {
                this.handleDraggingThrottled = null;
            }
            props.onEdit({
                // Because the new drawing feature is dropped, so the data will keep as the same.
                updatedData: props.data,
                editType: 'cancelFeature',
                editContext: {}
            });
        }
    }
}
//# sourceMappingURL=draw-polygon-by-dragging-mode.js.map